// useValidation.ts
import { useState, useEffect } from 'react';

type ValidationRule = {
  regex: RegExp;
  errorMessage: string;
};

const useValidation = (value: string, rules: ValidationRule[]) => {
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    for (const rule of rules) {
      if (!rule.regex.test(value)) {
        setError(rule.errorMessage);
        return;
      }
    }
    setError(null);
  }, [value, rules]);

  return error;
};

export default useValidation;
